export default __webpack_public_path__ + "static/media/13.a8cfcf4d.jpg";